module.exports = "/assets/data/6cf765dcfe96e72ad5d2302968e11ae4-NE25.data.json";